import React, { useState } from 'react';

import { IsActiveEnum, NonEmptyArray } from '_lib/api/apiTypes.shim';

import { MaskedPhoneDisplay } from '../MaskedPhoneDisplay/MaskedPhoneDisplay';
import { MenuItem } from '../MenuItem/MenuItem';
import { TextField, TextFieldProps } from '../TextField/TextField';

// TODO: move to a constant file somewhere
export const activeEnumOptions: NonEmptyArray<[IsActiveEnum, string]> = [
  [IsActiveEnum.Any, 'Any'],
  [IsActiveEnum.True, 'Active'],
  [IsActiveEnum.False, 'Inactive']
] as const;

type SelectFilterProps = Omit<TextFieldProps, 'onChange' | 'select'> & {
  /** index 0 is value, index 1 is displayValue, or string used for both */
  options: NonEmptyArray<[string, string]> | Array<string> | ReadonlyArray<string>;
  initialKey?: string | undefined;
  onChange: (selectedKey: string) => void;
  enableEmptyValue?: boolean;
  usePhoneMask?: boolean;
};

export const SelectFilter = (props: SelectFilterProps) => {
  const { options, initialKey, onChange, enableEmptyValue, usePhoneMask, ...textFieldProps } = props;

  const [selectedKey, setSelectedKey] = useState(() => {
    if (options.length === 1 && !enableEmptyValue) {
      const result = typeof options[0] === 'string' ? options[0] : options[0][0];
      onChange(result);
      return result;
    }
    return initialKey;
  });

  // This is needed to support the parent component changing the 'initialKey' without re-rendering
  const [lastInitialKey, setLastInitialKey] = useState(initialKey);
  if (initialKey !== undefined && lastInitialKey !== initialKey) {
    setLastInitialKey(initialKey);
    setSelectedKey(initialKey);
  }

  // if the 'options' changes and the selectedKey is not contained in it, clear out the selectedKey
  if (
    selectedKey &&
    options.length &&
    !options.find((option) => (typeof option === 'string' ? option === selectedKey : option[0] === selectedKey))
  ) {
    setSelectedKey(undefined);
  }

  return (
    <TextField
      disabled={options.length === 0}
      value={selectedKey}
      select
      onChange={(e) => {
        setSelectedKey(e.target.value);
        onChange(e.target.value);
      }}
      {...textFieldProps}>
      {enableEmptyValue && <MenuItem value=''>{'--'}</MenuItem>}
      {options.map((option) => {
        const value = typeof option === 'string' ? option : option[0];
        const display = typeof option === 'string' ? option : option[1];
        return (
          <MenuItem key={value} value={value}>
            {usePhoneMask ? <MaskedPhoneDisplay text={display} /> : display}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
